module.exports = {
  APP: 'app',
  ADMIN: 'admin',
  CONTACERTA: 'contacerta',
  ANTIFRAUD: 'antifraud',
  CUC: 'cuc'
};
